export default "__VITE_ASSET__VjNNeF$N__"